<template>
  <!-- <div class="control-section">
    <div class="col-md-8 control-section"> -->
  <div style="height: 100%; width: 100%; display: flex; justify-content: center;">
    <ejs-accumulationchart
      ref="pie"
      :theme="theme"
      style="display: block"
      align="center"
      :legendSettings="legendSettings"
      :tooltip="tooltip"
      enableSmartLables="true"
      :enableAnimation="enableAnimation"
      :center="center"
      height="300"
      width="450"
    >
      <e-accumulation-series-collection>
        <e-accumulation-series
          :palettes="palettes"
          :pointColorMapping="pointColorMapping"
          :dataSource="seriesData"
          :startAngle="startAngle"
          :endAngle="endAngle"
          :explodeOffset="explodeOffset"
          :explodeIndex="explodeIndex"
          :radius="radius"
          xName="x"
          yName="y"
          :dataLabel="dataLabel"
          innerRadius="0%"
          explode="true"
        >
        </e-accumulation-series>
      </e-accumulation-series-collection>
    </ejs-accumulationchart>
  </div>
</template>
<style scoped>
</style>
<script>
import Vue from "vue";
import {
  AccumulationChartPlugin,
  AccumulationTooltip,
  PieSeries,
  AccumulationDataLabel,
  AccumulationLegend,
} from "@syncfusion/ej2-vue-charts";
Vue.use(AccumulationChartPlugin);
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)
let selectedTheme = location.hash.split("/")[1];
selectedTheme = selectedTheme ? selectedTheme : "Material";
let theme = (
  selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
).replace(/-dark/i, "Dark");
export default Vue.extend({
  props: {
    approvalStatusList:{
      type:Array,
      default: () => []
    },
    notActedVoteCount:{
      type:Array,
      default: () => []
    },
    notActedConsentCount:{
      type:Array,
      default: () => []
    },
    consentStatusList:{
      type:Array,
      default: () => []
    },
    attendees:{
      type:Array,
      default: () => []
    },
    chartType: {
      type: String,
      default: 'vote' // vote/consent
    }
  },
  data() {
    return {
      theme: theme,
      // seriesData: [
      //   { x: "Chrome", y: 37, text: "37%", fill: "#6FAAB0" },
      //   { x: "UC Browser", y: 17, text: "17%", fill: "#228B22" },
      //   // { x: "iPhone", y: 19, text: "19%", fill: "#228B22" },
      //   // { x: "Others", y: 4, text: "4%", fill: "#498fff" },
      //   // { x: "Opera", y: 11, text: "11%", fill: "#498fff" },
      //   // { x: "Android", y: 12, text: "12%", fill: "#498fff" },
      // ],
      pointColorMapping: "fill",
      palettes: ["#52A75A", "#FF7171", "#FFAA2D", "#AEB6BF", "#3399FF", "#bdbebf"],
      dataLabel: {
        visible: true,
        position: "Inside",
        name: "text",
        font: {
          fontWeight: "600",
        },
      },
      enableSmartLabels: true,
      enableAnimation: false,
      legendSettings: {
      visible: true,
      position:'Bottom' ,alignment:'Near', width: '400', height: '80',
      },
      tooltip: { enable: true, format: "${point.x} : <b>${point.y}</b>" },
      startAngle: "0",
      endAngle: "360",
      radius: "100%",
      explodeOffset: "0",
      explodeIndex: 0,
      center: { x: "50%", y: "50%" },
      title: "Mobile Browser Statistics",
      chartImage: ''
    };
  },
   watch: {
    seriesData(val) {
      this.$refs.pie.ej2Instances.series[0].dataSource = val;
      this.$refs.pie.ej2Instances.dataBind();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
      this.$refs.pie.ej2Instances.refresh();
    },
  },
  computed: {
    noObjectionCount(){
      return this.consentStatusList.filter(f=>f?.consentStatus==='noObjection').length;
    },
    hasObjectionCount(){
       return this.consentStatusList.filter(f=>f?.consentStatus==='hasObjection').length;
    },
    noConsentResponseCount(){
       return this.consentStatusList.filter(f=>f?.consentStatus==='').length;
    },
    approvedCount(){
      return this.approvalStatusList.filter(f=>f.approvalStatus==='approve').length;      
    },
    rejectedCount(){
       return this.approvalStatusList.filter(f=>f.approvalStatus==='reject').length; 
    },
    abstainCount(){
       return this.approvalStatusList.filter(f=>f.approvalStatus==='abstain').length; 
    },
    seriesData() {
      let data=[];

      if(this.chartType == 'consent'){
        if(this.hasObjectionCount > 0){
            data.push({
                x: this.$t('agenda.btnHasObjection'),
                y: this.hasObjectionCount,
                text: `${(
                  (this.hasObjectionCount /
                  this.attendees.length) *
                  100
                ).toFixed(2)}%`,
                fill: this.palettes[1],
            });
          }
        if(this.noObjectionCount > 0){
          data.push({
              x: this.$t('agenda.btnNoObjection'),
              y: this.noObjectionCount,
              text: `${(
                (this.noObjectionCount /
                this.attendees.length) *
                100
              ).toFixed(2)}%`,
              fill: this.palettes[0],
          });
        }

        if((this.hasObjectionCount || this.noObjectionCount) && this.notActedConsentCount.length > 0){
          data.push({
              x: this.$t("agenda.lblNotActed"),
              y: this.notActedConsentCount.length,
              text: `${(
                (this.notActedConsentCount.length /
                this.attendees.length) *
                100
              ).toFixed(2)}%`,
              fill: this.palettes[5],
          });
        }
      }else{
        if(this.approvedCount>0){
              data.push({
                  x: this.$t('agenda.Approved'),
                  y: this.approvedCount,
                  text: `${(
                    (this.approvedCount /
                    this.attendees.length) *
                    100
                  ).toFixed(2)}%`,
                  fill: this.palettes[0],
              });
            }
        if(this.rejectedCount>0)
        {
        data.push({
              x: this.$t('agenda.Rejected'),
              y: this.rejectedCount,
              text: `${(
                (this.rejectedCount /
                this.attendees.length) *
                100
              ).toFixed(2)}%`,
              fill: this.palettes[1],
          });
        }
        if(this.abstainCount>0)
        {
        data.push({
              x: this.$t('agenda.Abstained'),
              y: this.abstainCount,
              text: `${(
                (this.abstainCount /
                this.attendees.length) *
                100
              ).toFixed(2)}%`,
              fill: this.palettes[2],
          });
        }
        if(this.notActedVoteCount.length > 0)
        {
        data.push({
              x: this.$t("agenda.lblNotActed"),
              y: this.notActedVoteCount.length,
              text: `${(
                (this.notActedVoteCount.length /
                this.attendees.length) *
                100
              ).toFixed(2)}%`,
              fill: this.palettes[5],
          });
        }
      }
      return data;
    },
  },
  provide: {
    accumulationchart: [
      AccumulationLegend,
      PieSeries,
      AccumulationTooltip,
      AccumulationDataLabel,
    ],
  },
  
  methods: {
    generateSvg(){
      let obj = this;
      var svgData = new XMLSerializer().serializeToString(obj.$refs.pie.ej2Instances.svgObject); 
      var img = document.createElement("img"); 
      img.setAttribute( 
        "src", 
        "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData))) 
      ); 
      this.chartImage = img.src
      setTimeout(function(){ 
        obj.$refs.html2Pdf.generatePdf()
       }, 1000);
      
    },
    generateSvgOld(){
      let obj = this;
      let format = 'image/jpeg';
      // Getting pages as image
      let image = obj.$refs.pie.ej2Instances.accumulationchart.exportAsImage(i, format);
      image.onload = function () {
      }
      let pdfdocument = new PdfDocument();
      let count = obj.$refs.pie.ej2Instances.accumulationchart.pageCount;
      obj.$refs.pie.ej2Instances.accumulationchart.documentEditorSettings.printDevicePixelRatio = 2;
      let loadedPage = 0;
      for (let i = 1; i <= count; i++) {
        setTimeout(() => {
          let format = 'image/jpeg';
          // Getting pages as image
          let image = obj.$refs.pie.ej2Instances.accumulationchart.exportAsImage(i, format);
          image.onload = function () {
            let imageHeight = parseInt(
              image.style.height.toString().replace('px', '')
            );
            let imageWidth = parseInt(
              image.style.width.toString().replace('px', '')
            );
            let section = pdfdocument.sections.add();
            let settings = new PdfPageSettings(0);
            if (imageWidth > imageHeight) {
              settings.orientation = PdfPageOrientation.Landscape;
            }
            settings.size = new SizeF(imageWidth, imageHeight);
            (section).setPageSettings(settings);
            let page = section.pages.add();
            let graphics = page.graphics;
            let imageStr = image.src.replace('data:image/jpeg;base64,', '');
            let pdfImage = new PdfBitmap(imageStr);
            graphics.drawImage(pdfImage, 0, 0, imageWidth, imageHeight);
            loadedPage++;
            if (loadedPage == count) {
                // Exporting the document as pdf
              pdfdocument.save(
                (obj.$refs.pie.ej2Instances.accumulationchart.documentName === ''
                  ? 'sample'
                  : obj.$refs.pie.ej2Instances.accumulationchart.documentName) + '.pdf'
              );
            }
          };
        }, 500);
      }
    },
    pieangle(e) {
      let angle = document.getElementById("pieangle").value;
      this.endAngle = +angle;
      this.startAngle = +angle;
      document.getElementById("anglevalue").innerHTML = angle;
    },
    pieradius(e) {
      let rad = document.getElementById("pieradius").value;
      this.radius = rad + "%";
      document.getElementById("radiusid").innerHTML = (rad / 100).toFixed(2);
    },
    pieexploderadius(e) {
      let rad = document.getElementById("pieexploderadius").value;
      this.explodeOffset = rad + "%";
      document.getElementById("exploderadius").innerHTML = (rad / 100).toFixed(
        2
      );
    },
    pieexplodeindex(e) {
      let index = document.getElementById("pieexplodeindex").value;
      this.explodeIndex = +index;
      document.getElementById("explodeindex").innerHTML = index;
    },
    piecenterx(e) {
      let x = document.getElementById("x").value;
      this.$refs.pie.ej2Instances.center.x = x + "%";
      document.getElementById("xvalue").innerHTML = x + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },
    piecentery(e) {
      let y = document.getElementById("y").value;
      this.$refs.pie.ej2Instances.center.y = y + "%";
      document.getElementById("yvalue").innerHTML = y + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },
  },
});
</script>
<style>
.e-chart {
  height: 200px !important;
  width: 200px !important;
}
</style>